import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/images/lpp.jpg'


const _hoisted_1 = { class: "wp1200 withPadding survey" }
const _hoisted_2 = { class: "mainTitle" }
const _hoisted_3 = { class: "surveyMainTitle" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_5 = { class: "flex" }
const _hoisted_6 = { class: "col2_3" }
const _hoisted_7 = ["alt"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, " Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat. ", -1)
const _hoisted_9 = { class: "surveyNextButton" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "icon-warpit_icon_arrow-R" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createStaticVNode("<div class=\"col1_3\"><ul class=\"none\"><li><i class=\"icon-warpit_icon_loyalty-point\"></i> <span>150</span></li><li><i class=\"icon-warpit_icon_clock\"></i> <span>7 min</span></li><li><i class=\"icon-warpit_icon_calendar\"></i><span> 02.02.2022 - 02.22.2022</span></li></ul></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.$t("survey.title")), 1),
      _hoisted_4
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("img", {
          src: _imports_0,
          alt: _ctx.$t('accessibility.survey.survey_image')
        }, null, 8, _hoisted_7),
        _hoisted_8,
        _createElementVNode("button", _hoisted_9, [
          _createTextVNode(_toDisplayString(_ctx.$t("survey.start")) + " ", 1),
          _hoisted_10
        ])
      ]),
      _hoisted_11
    ])
  ]))
}